import React, { memo, useState, useEffect } from "react";
import { validators } from "investira.sdk";
import { Stack, Divider, Button, Icon, Typography } from "investira.react.components";
import { useCarteirasContext } from "../../contexts/CarteirasContext";
import { DialogAddRecursoGarantidor } from "../../components/organisms";
import AtivosFilters from "./AtivosFilters";
import AtivosDataGrid from "./AtivosDataGrid";
import DialogAddAtivo from "./DialogAddAtivo";
import DialogCloneCarteira from "./DialogCloneCarteira";
import DialogCarteiraEdit from "./DialogCarteiraEdit";
import DialogPosicao from "./DialogPosicao";
import DialogTipoEdit from "./DialogTipoEdit";
import Abertura from "./Abertura";
import CopiarDataButtonDialog from "./CopiarDataButtonDialog";
import PosicaoDeleteButtonDialog from "./PosicaoDeleteButtonDialog";
import usePerfil from "../../hooks/usePerfil";
const AtivosList = memo(props => {
  const {
    state,
    actions
  } = useCarteirasContext();
  const [filters, setFilters] = useState({});
  const [values, setValues] = useState({});
  const [posicoes, setPosicoes] = useState([]);
  const {
    usuarioPrioridade
  } = usePerfil();
  const hasFND = state.posicoes.some(xItem => xItem.mercado === "FND");
  function somaPosicao(pPosicao) {
    let xResult = pPosicao.reduce((xAcc, xPosicao) => {
      return xAcc + Math.round(xPosicao.financeiro * 1e7) / 1e7;
    }, 0);
    return xResult;
  }
  function formatNumber(value, decimals = 2) {
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }
  function bestMatch(pValues, pData, pKey, pValue) {
    const xData = pData.filter(xItem => {
      return xItem[pKey] === pValue;
    });
    let xMaxMatches = 0;
    let xBestMatchIndex = -1;
    xData.forEach((xItem, xIndex) => {
      let xMatchCount = 0;
      for (const xKey in pValues) {
        if (pValues.hasOwnProperty(xKey) && xItem[xKey] === pValues[xKey]) {
          xMatchCount++;
        }
      }
      if (xMatchCount > xMaxMatches) {
        xMaxMatches = xMatchCount;
        xBestMatchIndex = xIndex;
      }
    });
    const xNewState = xData[xBestMatchIndex];
    return xNewState;
  }
  function getFilterValues(pArr, pAttr) {
    const xSet = new Set();
    pArr.forEach(xItem => {
      xSet.add(xItem[pAttr]);
    });
    return Array.from(xSet);
  }
  function defineFilters(pUniques, pCurrentFilter) {
    const xDisponivel = pUniques;
    const xAtivoTipo = xDisponivel.filter(xItem => xItem.mercado === pCurrentFilter.mercado);
    const xFilters = {
      mercados: getFilterValues(xDisponivel, "mercado"),
      ativos_tipo: getFilterValues(xAtivoTipo, "ativo_tipo_id")
    };
    return xFilters;
  }
  function filterUniques(pPosicoes) {
    const xUniqueSet = new Set();
    const xResult = [];
    pPosicoes.forEach(xItem => {
      const {
        mercado,
        ativo_tipo_id
      } = xItem;
      const xKey = `${mercado}-${ativo_tipo_id}`;
      if (!xUniqueSet.has(xKey)) {
        xUniqueSet.add(xKey);
        xResult.push({
          mercado,
          ativo_tipo_id
        });
      }
    });
    return xResult;
  }
  function handleDeleteClick(pPosicoes) {
    actions.handleBulkRemovePosicoes(pPosicoes);
  }
  function handleEditClick(pObjPosicao) {
    actions.handleEditPosicao(pObjPosicao);
  }
  function handleChangeValues(pNewValue, pPosicoes) {
    const isAtivoTipoId = Object.keys(pNewValue)[0] === "ativo_tipo_id";
    const isMercado = Object.keys(pNewValue)[0] === "mercado";
    if (validators.isNull(pNewValue.mercado) && !isAtivoTipoId) {
      setValues({
        mercado: null,
        ativo_tipo_id: null
      });
      setFilters(prevState => {
        return {
          ...prevState,
          ativos_tipo: [null]
        };
      });
    } else if (isMercado && pNewValue.mercado !== null) {
      const xFilter = Object.entries(pNewValue)[0];
      const xKey = xFilter[0];
      const xValue = xFilter[1];
      const xUniques = filterUniques(pPosicoes);
      setValues(prevState => {
        let xNewValues = {
          ativo_tipo_id: null,
          mercado: pNewValue.mercado
        };
        const xNewState = bestMatch(xNewValues, xUniques, xKey, xValue);
        const xFilters = defineFilters(pPosicoes, xNewState, xKey);
        setFilters(xFilters);
        return xNewValues;
      });
    } else if (isAtivoTipoId && pNewValue.ativo_tipo_id === null) {
      setValues(prevState => {
        return {
          ...prevState,
          ativo_tipo_id: null
        };
      });
    } else {
      const xFilter = Object.entries(pNewValue)[0];
      const xKey = xFilter[0];
      const xValue = xFilter[1];
      const xUniques = filterUniques(pPosicoes);
      setValues(prevState => {
        let xNewValues = {
          ...prevState,
          ...pNewValue
        };
        const xNewState = bestMatch(xNewValues, xUniques, xKey, xValue);
        const xFilters = defineFilters(pPosicoes, xNewState, xKey);
        setFilters(xFilters);
        return xNewState;
      });
    }
  }
  function handleDeletePosicao(pResolve = null, pReject = null, pFinally = null) {
    const {
      carteira_id,
      data_posicao
    } = state;
    actions.deletePosicoes({
      carteira_id,
      data: data_posicao
    }, pResolve, pReject, pFinally);
  }
  useEffect(() => {
    const {
      carteira_id,
      data_posicao
    } = state;
    if (validators.isNull(carteira_id) && validators.isNull(data_posicao)) {
      console.error("É necessário informar carteira e data");
    } else {
      actions.readPosicoes({
        carteira_id,
        data: data_posicao
      }, rRes => {
        actions.handleBulkAddPosicoes(rRes.data);
      });
      actions.readDatasPosicoes(carteira_id, rRes => {
        actions.handleSetDatasPosicoes(rRes.data);
      });
    }
  }, [state.carteira_id]);
  useEffect(() => {
    const xMercados = getFilterValues(state.posicoes, "mercado");
    const xAtivosTipo = getFilterValues(state.posicoes, "ativo_tipo_id");
    let xFilters = {
      mercados: xMercados,
      ativos_tipo: xAtivosTipo
    };
    const xInitValues = {
      mercado: xFilters.mercados[0],
      ativo_tipo_id: xFilters.ativos_tipo[0]
    };
    const xUniques = filterUniques(state.posicoes);
    xFilters = defineFilters(xUniques, xInitValues);
    setFilters(xFilters);
    setValues(xInitValues);
    //setFilters({ ...xFilters, ativos_tipo: [null] });
    //setValues({ mercado: null, ativo_tipo_id: null });
  }, [state.posicoes]);
  useEffect(() => {
    if (!validators.isNull(values.mercado) && validators.isNull(values.ativo_tipo_id)) {
      const xPosicoesFiltradas = state.posicoes.filter(xPosicao => {
        return xPosicao.mercado === values.mercado;
      });
      setPosicoes(xPosicoesFiltradas);
    } else if (!validators.isNull(values.mercado)) {
      const xPosicoes = state.posicoes.filter(xItem => {
        const xMatchMercado = xItem.mercado === values.mercado;
        const xMatchTipo = xItem.ativo_tipo_id === values.ativo_tipo_id;
        return xMatchMercado && xMatchTipo;
      });
      setPosicoes(xPosicoes);
    } else {
      setPosicoes(state.posicoes);
    }
  }, [state.posicoes, values]);

  // useEffect(() => {
  //   // Ativa "Todos" ao iniciar
  //   const xMercados = getFilterValues(state.posicoes, "mercado");
  //   const xAtivosTipo = getFilterValues(state.posicoes, "ativo_tipo_id");

  //   let xFilters = {
  //     mercados: xMercados,
  //     ativos_tipo: xAtivosTipo,
  //   };

  //   const xInitValues = {
  //     mercado: xFilters.mercados[0],
  //     ativo_tipo_id: xFilters.ativos_tipo[0],
  //   };

  //   const xUniques = filterUniques(state.posicoes);

  //   xFilters = defineFilters(xUniques, xInitValues);

  //   setFilters({ ...xFilters, ativos_tipo: [null] });
  //   setValues({ mercado: null, ativo_tipo_id: null });
  // }, []);

  if (validators.isNull(props.carteiraId)) {
    return null;
  }

  //TODO: LOADING

  return <>
      <DialogAddAtivo mercado={values.mercado} onCreate={setValues} />
      <DialogCloneCarteira />
      <DialogCarteiraEdit />
      <DialogTipoEdit />
      <DialogPosicao />
      <DialogAddRecursoGarantidor />

      <Stack spacing={2} sx={{
      py: 3
    }}>
        <Stack direction="column" spacing={2}>
          {usuarioPrioridade <= 6 && !props.hasCid && <Stack flexWrap={{
          xs: "nowrap",
          sm: "wrap"
        }} direction={{
          xs: "column",
          sm: "row"
        }} gap={{
          xs: 1,
          sm: 2
        }} alignItems={{
          xs: "flex-start",
          sm: "center"
        }}>
              {state.data_posicao && <Abertura carteiraTipoId={state.carteira_tipo_id} carteiraId={state.carteira_id} dataPosicao={state.data_posicao} datasPosicoes={state.datas_posicoes} hasFND={hasFND} />}

              <Stack flexWrap="wrap" direction="row" gap={{
            xs: 1
          }}>
                <CopiarDataButtonDialog disabled={validators.isNull(props.carteiraId) && validators.isEmpty(state.data_posicao)} />
                <Button disabled={validators.isNull(props.carteiraId) && validators.isEmpty(state.data_posicao)} variant="contained" color="primary" startIcon={<Icon iconName="folder" size={14} />} size="small" sx={{
              px: 2
            }} onClick={actions.handleClonePosicao}>
                  Copiar Posição
                </Button>
                <Button disabled={validators.isNull(props.carteiraId)} variant="contained" color="primary" startIcon={<Icon iconName="insert" size={14} />} size="small" sx={{
              px: 2
            }} onClick={actions.handleNewPosicao}>
                  Adicionar Ativo
                </Button>
              </Stack>

              {!validators.isEmpty(posicoes) && <>
                  <Divider orientation="vertical" flexItem />
                  <PosicaoDeleteButtonDialog disabled={validators.isNull(props.carteiraId)} onDelete={handleDeletePosicao} dataPosicao={state.data_posicao} />
                </>}
            </Stack>}

          {!props.hasCid && <Divider flexItem />}
          <Stack direction={"row"} spacing={2} alignItems="center">
            <AtivosFilters filters={filters} values={values} onChange={pValue => handleChangeValues(pValue, state.posicoes)} />
            {!validators.isEmpty(posicoes) && <>
                <Stack>
                  <Typography variant="body2" color={"textPrimary"} sx={{
                fontWeight: 600
              }}>
                    Financeiro: {formatNumber(somaPosicao(posicoes), 2)}
                  </Typography>
                </Stack>
              </>}
          </Stack>
        </Stack>

        <Divider />
        <AtivosDataGrid posicoes={posicoes} mercado={values.mercado} ativoTipoId={values.ativo_tipo_id} carteiraId={props.carteiraId} hasCid={props.hasCid} actions={{
        edit: handleEditClick,
        delete: handleDeleteClick
      }} />
      </Stack>
    </>;
});
AtivosList.displayName = "AtivosList";
export default AtivosList;
